import React from "react";
import { cn } from "../../lib/utils";

const Button = React.forwardRef(
  ({ className, variant = "default", size = "md", ...props }, ref) => {
    const variants = {
      default: "btn-default",
      ghost: "btn-ghost",
      destructive: "btn-destructive",
    };

    const sizes = {
      sm: "btn-sm",
      md: "btn-md",
      lg: "btn-lg",
    };

    return (
      <button
        ref={ref}
        className={cn("btn", variants[variant], sizes[size], className)}
        {...props}
      />
    );
  }
);

export { Button };
